import { render, staticRenderFns } from "./CouponField.vue?vue&type=template&id=1cd00e58&scoped=true"
import script from "./CouponField.vue?vue&type=script&lang=js"
export * from "./CouponField.vue?vue&type=script&lang=js"
import style0 from "./CouponField.vue?vue&type=style&index=0&id=1cd00e58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd00e58",
  null
  
)

export default component.exports